export function formatCurrency(
  value: number,
  locale = 'en-US',
  currency = 'USD',
  decimalLimit = 2,
) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: Math.floor(value) === value ? 0 : decimalLimit,
  }).format(value);
}
